import { Box, Tab, TabProps, Tabs, TabsProps } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

interface TabItem {
  label: string;
  value: string | number;
  content: ReactNode;
  icon?: ReactElement;
}

interface CustomTabsProps extends Omit<TabsProps, 'onChange'> {
  tabs: TabItem[];
  value: string | number;
  onChange: (event: React.SyntheticEvent, newValue: string | number) => void;
  tabProps?: Omit<TabProps, 'label' | 'value'>;
  contentProps?: React.ComponentProps<typeof Box>;
  wrapperProps?: React.ComponentProps<typeof Box>;
}

export const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  value,
  onChange,
  tabProps,
  contentProps,
  wrapperProps,
  ...tabsProps
}) => {
  return (
    <Box {...wrapperProps}>
      <Tabs value={value} onChange={onChange} {...tabsProps}>
        {tabs.map(tab => (
          <Tab key={tab.value} icon={tab.icon} label={tab.label} value={tab.value} {...tabProps} />
        ))}
      </Tabs>
      <Box {...contentProps}>{tabs.find(tab => tab.value === value)?.content}</Box>
    </Box>
  );
};
